import {Injectable} from "@angular/core";
import {AbstractSQLService} from "./AbstractSQLService";
import {TipoMarcacao} from "../../../domain/TipoMarcacao";

@Injectable()
export class TipoMarcacaoSQLService extends AbstractSQLService<TipoMarcacao>{
    nomeTabela = "tipo_marcacao"
  agenciavel = false
}
